import React, { FC } from 'react';
import Lozenge from '@atlaskit/lozenge';
import Tooltip from '@atlaskit/tooltip';
import QuestionCircleIcon from '@atlaskit/icon/glyph/question-circle';
import { token } from '@atlaskit/tokens';

import { flexCenter, spaceGapMinimum, tooltipStyles } from '@/styles';
import { ExternalLinkAction } from '@/components/primitive';
import { DAC_FAQS_DOC_LINK } from '@/constants';

import { captionPrefixStyles, tooltipIconFixPositionStyls } from './styles';

type LowTrafficTagProps = {
  showLowTrafficTooltip?: boolean;
};

const LowTrafficTag: FC<LowTrafficTagProps> = ({ showLowTrafficTooltip = false }) => (
  <span css={[spaceGapMinimum, flexCenter]}>
    <span css={captionPrefixStyles}>in</span>
    <Lozenge>low traffic</Lozenge>
    {showLowTrafficTooltip && (
      <Tooltip
        content={
          <span css={tooltipStyles}>
            These alerts are triggered when the SLO is in a low traffic state
            <br />
            <br />
            <ExternalLinkAction
              text="Find out more"
              href={`${DAC_FAQS_DOC_LINK}low-traffic-slos/#low-traffic-slos/#when-is-the-slo-in-a-low-traffic-state-`}
              hideIcon
            />
          </span>
        }
        position="right"
      >
        <span css={tooltipIconFixPositionStyls}>
          <QuestionCircleIcon
            label="question-icon"
            size="small"
            primaryColor={token('color.text.subtlest')}
          />
        </span>
      </Tooltip>
    )}
  </span>
);

export default LowTrafficTag;
